import cartAPI from 'apis/cart';

import type { CartProductForCreate } from 'domains/cart_products';

export const create = async (cp: CartProductForCreate) => {
  const { data } = await cartAPI.post<{ id: number }>('/products', cp);
  return data;
};

export const destroy = async (id: number) => {
  await cartAPI.delete(`/products/${id}`);
  return id;
};
